import { toTitleCase } from "../../../../Utils/stringUtls";
import React from "react";
const CustomerServiceWebsiteOverview = ({ data }) => {
  const {
    ic_csw_web_agent_required,
    ic_csw_website_language,
    ic_csw_website_language_other,
    users,
  } = data["7_1"];
  return (
    <div
      className="forms-instance review-summary-sub-heading"
      style={{ marginTop: "16px" }}
    >
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="12@md">
          <div className="fw-700 font-bold">
            Customer Service Website (C-Agent)
          </div>
          <div className="overview-help-text-for-heading">
            This site facilitates your bank and support staff to log, track and
            manage customer inquiries, search for cardholders, change cardholder
            profiles, view transaction details, reverse / applied fee etc. It
            also allows them to view card program details and parameters.
          </div>
        </div>

        <div i2c-grid="12">
          <div className="overview-help-text font-bold">
            Would you like i2c C-Agent Website?
          </div>
          <div className="overview-val-text">
            {ic_csw_web_agent_required?.length
              ? toTitleCase(ic_csw_web_agent_required)
              : "-"}
          </div>
        </div>
        {ic_csw_web_agent_required === "yes" && (
          <>
            <div i2c-grid="12">
              <div className="overview-help-text font-bold">
                C-Agent Website Language
              </div>
              <div className="overview-val-text">
                {ic_csw_website_language[0]?.length &&
                ic_csw_website_language[0] !== "other"
                  ? `${toTitleCase(ic_csw_website_language[0])}`
                  : ""}
                {ic_csw_website_language[1]?.length &&
                ic_csw_website_language[1] !== "other"
                  ? `, ${toTitleCase(ic_csw_website_language[1])}`
                  : ""}
                {ic_csw_website_language[2]?.length &&
                ic_csw_website_language[2] !== "other"
                  ? `, ${toTitleCase(ic_csw_website_language[2])}`
                  : ""}
                {ic_csw_website_language_other?.length
                  ? `, ${toTitleCase(ic_csw_website_language_other)}`
                  : ""}
              </div>
            </div>
            <div i2c-grid="12@md">
              <div className="fw-700 font-bold">User Details</div>
              <div className="overview-help-text-for-heading">
                Please provide the email address, Name and Contact information
                of individuals who will require administrator access.
              </div>
            </div>

            {users.length
              ? users.map((user, index) => {
                  const {
                    iac_aw_cell,
                    iac_aw_cell_country,
                    iac_aw_email,
                    iac_aw_fax,
                    iac_aw_fax_country,
                    iac_aw_name,
                    iac_aw_phone,
                    iac_aw_phone_country,
                    iac_aw_title,
                  } = user;
                  return (
                    <React.Fragment key={index}>
                      <div i2c-grid="12@md" className="fw-700 font-bold">
                        User {index + 1}
                      </div>
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">Name</div>
                        <div className="overview-val-text">
                          {iac_aw_name?.length ? toTitleCase(iac_aw_name) : "-"}
                        </div>
                      </div>
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Title
                        </div>
                        <div className="overview-val-text">
                          {iac_aw_title?.length
                            ? toTitleCase(iac_aw_title)
                            : "-"}
                        </div>{" "}
                      </div>

                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Phone Number
                        </div>
                        <div className="overview-val-text">
                          {iac_aw_phone?.length ? iac_aw_phone : "-"}
                        </div>{" "}
                      </div>
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Cell Number
                        </div>
                        <div className="overview-val-text">
                          {iac_aw_cell?.length ? iac_aw_cell : "-"}
                        </div>{" "}
                      </div>
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">Fax</div>
                        <div className="overview-val-text">
                          {iac_aw_fax?.length ? iac_aw_fax : "-"}
                        </div>{" "}
                      </div>
                      <div i2c-grid="6@md">
                        <div className="overview-help-text font-bold">
                          Email
                        </div>
                        <div className="overview-val-text">
                          {iac_aw_email?.length ? iac_aw_email : "-"}
                        </div>{" "}
                      </div>
                    </React.Fragment>
                  );
                })
              : ""}
          </>
        )}
      </div>
    </div>
  );
};
export default CustomerServiceWebsiteOverview;
